import * as React from 'react';
import CardContainer from '../common/CardContainer';
import { Card } from '@blueprintjs/core';
import CardScrollSection from '../common/CardScrollSection';

type MainPageContractorProps = {
    trackedProjects: Array<JSX.Element>;
    taskItems: Array<JSX.Element>;
    tasksIsLoading: boolean;
};

const mainPageContractor: React.SFC<MainPageContractorProps> = (props: MainPageContractorProps) => {
    return (
        <CardContainer height="400px">
            <Card elevation={2}>
                <div className="card-header lh-mb-small">Assigned Projects</div>
                <CardScrollSection height="330px" emptyMessage="No Tracked Projects">
                    {props.trackedProjects}
                </CardScrollSection>
            </Card>
            <Card elevation={2}>
                <div className="card-header lh-mb-small">Tasks</div>
                <CardScrollSection height="330px" emptyMessage="No Tasks">
                    {props.taskItems}
                </CardScrollSection>
            </Card>
            <Card elevation={2}>
                <div className="card-header lh-mb-small">Time</div>
                TODO
            </Card>
        </CardContainer>
    );
};

export default mainPageContractor;



// WEBPACK FOOTER //
// ./src/components/main/MainPage.Contractor.tsx